import React, {Component} from 'react';
import {BootstrapField, BootstrapError} from "../../helpers/Field";
import * as yup from 'yup';
import {Formik} from "formik";
import {passwordResetRequest} from "../../requests/UserRequests";
import BackToLogin from "../BackToLogin";
import SimpleHeader from "../header/SimpleHeader";
import Footer from "../footer/Footer";

class ResetPasswordPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      message: null,
    }
  }

  render() {
    return (
      <React.Fragment>
        <SimpleHeader/>
        <div className={"container mt-5"}>
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mx-auto">
              {!this.state.message && <div className="card">
                <Formik
                  validationSchema={yup.object().shape({email: yup.string().email().required()})}
                  onSubmit={(values, bag) => {
                    passwordResetRequest(values).then((message) => {
                      this.setState({message});
                    })
                  }}
                  render={props =>
                    <form onSubmit={props.handleSubmit}>
                      <div className={"form-group"}>
                        <label>Email</label>
                        <BootstrapField name="email" type={"email"} placeholder={"email"}/>
                        <BootstrapError name={"email"}/>
                      </div>
                      <div>
                        <button type={"submit"} className={"btn btn-primary"}>Reset Password</button>
                      </div>
                    </form>
                  }/>
              </div>
              }
              {this.state.message && <React.Fragment>
                <div className="card">
                  {this.state.message}
                </div>
                <div className="row justify-content-center flex mt-3">
                  <BackToLogin/>
                </div>
              </React.Fragment>
              }
            </div>
          </div>
                <div className="container" style={{ marginTop: "100px" }}>
                    <div className="row">
                        <div className="col-md-8 mx-auto">
                            <p className="text-left">
                                <b>Protecting Your Schindler E-Pay Account and Payments</b> For your security, effective immediately, we are requiring all users to update your password. Please use a strong, unique combination. If you receive any request to use a different payment method, always confirm the request with your trusted Schindler contact before taking action. These steps help safeguard your information and prevent fraudulent activity.
                            </p>
                        </div>
                    </div>
                </div>
        </div>
        <Footer/>
      </React.Fragment>
    );
  }
}

ResetPasswordPage.propTypes = {};

export default ResetPasswordPage;
